module.exports = __webpack_public_path__ + "static/media/129.c4dbe2c2.png";